/*!
 * Link Click tracking for Snowplow v0.3.13 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).snowplowLinkClickTracking = {});
}(this, function (e) {
  function t(e) {
    for (var t, n = [], r = 1; r < arguments.length; r++) {
      n[r - 1] = arguments[r];
    }

    return null !== (t = null == e ? void 0 : e.map(function (e) {
      if ("function" != typeof e) return e;

      try {
        return e.apply(void 0, n);
      } catch (e) {}
    }).filter(Boolean)) && void 0 !== t ? t : [];
  }

  function n(e) {
    var t = e.event;
    e = t.sc;
    var n = t.dt;
    return t = function () {
      var e,
          t = {},
          n = [],
          r = [],
          o = [],
          i = function i(e, n) {
        null != n && "" !== n && (t[e] = n);
      };

      return {
        add: i,
        addDict: function addDict(e) {
          for (var t in e) {
            Object.prototype.hasOwnProperty.call(e, t) && i(t, e[t]);
          }
        },
        addJson: function addJson(e, t, o) {
          var i;
          if (i = o) e: {
            if (null != o && (o.constructor === {}.constructor || o.constructor === [].constructor)) for (var a in o) {
              if (Object.prototype.hasOwnProperty.call(o, a)) {
                i = !0;
                break e;
              }
            }
            i = !1;
          }
          i && (e = {
            keyIfEncoded: e,
            keyIfNotEncoded: t,
            json: o
          }, r.push(e), n.push(e));
        },
        addContextEntity: function addContextEntity(e) {
          o.push(e);
        },
        getPayload: function getPayload() {
          return t;
        },
        getJson: function getJson() {
          return n;
        },
        withJsonProcessor: function withJsonProcessor(t) {
          e = t;
        },
        build: function build() {
          return null == e || e(this, r, o), t;
        }
      };
    }(), e = {
      sc: "sp/ue/1-0-0",
      dt: {
        sc: e,
        dt: n
      }
    }, t.add("e", "ue"), t.addJson("ue_px", "ue_pr", e), t;
  }

  function r(e) {
    return n({
      event: e = {
        sc: "sp/lc/1-0-1",
        dt: i({
          targetUrl: e.targetUrl,
          elementId: e.elementId,
          elementClasses: e.elementClasses,
          elementTarget: e.elementTarget,
          elementContent: e.elementContent
        })
      }
    });
  }

  function o(e) {
    return n({
      event: e = {
        sc: "cv/bc/1-0-0",
        dt: i({
          elementType: e.elementType,
          elementId: e.elementId,
          elementClasses: e.elementClasses,
          elementName: e.elementName,
          elementText: e.elementText,
          elementValue: e.elementValue
        })
      }
    });
  }

  function i(e, t) {
    void 0 === t && (t = {});
    var n,
        r = {};

    for (n in e) {
      (t[n] || null !== e[n] && void 0 !== e[n]) && (r[n] = e[n]);
    }

    return r;
  }

  function a(e, t, n, r) {
    return e.addEventListener ? (e.addEventListener(t, n, r), !0) : e.attachEvent ? e.attachEvent("on" + t, n) : void (e["on" + t] = n);
  }

  function c(e) {
    if (null == e || "object" != _typeof(e) || Array.isArray(e)) return function () {
      return !0;
    };

    var t = Object.prototype.hasOwnProperty.call(e, "allowlist"),
        n = function (e) {
      var t = {};

      if (e = e.allowlist || e.denylist) {
        Array.isArray(e) || (e = [e]);

        for (var n = 0; n < e.length; n++) {
          t[e[n]] = !0;
        }
      }

      return t;
    }(e);

    return function (e, t) {
      return e.hasOwnProperty("filter") && e.filter ? e.filter : t;
    }(e, function (e) {
      e: {
        var r = 0;

        for (e = e.className.match(/\S+/g) || []; r < e.length; r++) {
          if (n[e[r]]) {
            r = !0;
            break e;
          }
        }

        r = !1;
      }

      return r === t;
    });
  }

  function l(e, n, o) {
    for (var i, a, c, l; null !== (i = n.parentElement) && null != i && "A" !== (a = n.tagName.toUpperCase()) && "AREA" !== a;) {
      n = i;
    }

    if (null != (i = n).href) {
      (a = i.hostname) || (a = i.href, a = (c = /^(?:(?:https?|ftp):)\/*(?:[^@]+@)?([^:/#]+)/.exec(a)) ? c[1] : a), c = a.toLowerCase();
      var s = i.href.replace(a, c);
      /^(javascript|vbscript|jscript|mocha|livescript|ecmascript|mailto):/i.test(s) || (a = i.id, c = i.className.match(/\S+/g) || [], l = i.target, i = N[e.id].linkTrackingContent ? i.innerHTML : void 0, i = {
        targetUrl: s = unescape(s),
        elementId: a,
        elementClasses: c,
        elementTarget: l,
        elementContent: i
      }, e.core.getConfig().linkClickTracking && e.core.track(r(i), t(o, n)));
    }
  }

  function s(e, n, r) {
    for (var i; null !== (i = n.parentElement) && null != i && "BUTTON" !== n.tagName.toUpperCase();) {
      n = i;
    }

    i = {
      elementType: (i = n).type,
      elementId: i.id,
      elementClasses: i.className || "",
      elementName: i.name,
      elementText: i.innerText,
      elementValue: i.value
    }, e.core.getConfig().buttonClickTracking && e.core.track(o(i), t(r, n));
  }

  function u(e, t) {
    return function (n) {
      var r = (n = n || window.event).which || n.button,
          o = n.target || n.srcElement;
      "click" === n.type ? o && l(O[e], o, t) : "mousedown" === n.type ? 1 !== r && 2 !== r || !o ? N[e].lastButton = N[e].lastTarget = null : (N[e].lastButton = r, N[e].lastTarget = o) : "mouseup" === n.type && (r === N[e].lastButton && o === N[e].lastTarget && l(O[e], o, t), N[e].lastButton = N[e].lastTarget = null);
    };
  }

  function d(e, t) {
    return function (n) {
      var r = (n = n || window.event).which || n.button,
          o = n.target || n.srcElement;
      "click" === n.type ? o && s(O[e], o, t) : "mousedown" === n.type ? 1 !== r && 2 !== r || !o ? _[e].lastButton = _[e].lastTarget = null : (_[e].lastButton = r, _[e].lastTarget = o) : "mouseup" === n.type && (r === _[e].lastButton && o === _[e].lastTarget && s(O[e], o, t), _[e].lastButton = _[e].lastTarget = null);
    };
  }

  function f(e, t) {
    e = void 0 === e ? {} : e, N[t] = {
      linkTrackingContent: e.trackContent,
      linkTrackingContext: e.context,
      linkTrackingPseudoClicks: e.pseudoClicks,
      linkTrackingFilter: c(e.options)
    };
  }

  function k(e, t) {
    e = void 0 === e ? {} : e, _[t] = {
      buttonTrackingContent: e.trackContent,
      buttonTrackingContext: e.context,
      buttonTrackingFilter: c(e.options)
    };
  }

  function v(e) {
    var t,
        n,
        r,
        o = document.links;

    for (b = e, r = 0; r < o.length; r++) {
      if (null !== (n = null === (t = N[e]) || void 0 === t ? void 0 : t.linkTrackingFilter) && void 0 !== n && n.call(t, o[r]) && !o[r][e]) {
        var i = e,
            c = o[r];
        N[i].linkTrackingPseudoClicks ? (a(c, "mouseup", u(i, N[i].linkTrackingContext), !1), a(c, "mousedown", u(i, N[i].linkTrackingContext), !1)) : a(c, "click", u(i, N[i].linkTrackingContext), !1), o[r][e] = !0;
      }
    }
  }

  function p(e) {
    try {
      for (var t = 0; t < e.length; t++) {
        "childList" === e[t].type && (v(b), g(b));
      }
    } catch (e) {
      console.warn("Conviva App Tracker caused Exception in mutation callback of click tracking Plugin", e);
    }
  }

  function g(e) {
    var t,
        n,
        r,
        o = document.querySelectorAll("button");

    for (r = 0; r < o.length; r++) {
      null !== (n = null === (t = _[e]) || void 0 === t ? void 0 : t.buttonTrackingFilter) && void 0 !== n && n.call(t, o[r]) && !o[r][e] && (a(o[r], "click", d(e, _[e].buttonTrackingContext), !1), o[r][e] = !0);
    }
  }

  var E, h, T, m, C, y;
  (h = E || (E = {}))[h.none = 0] = "none", h[h.error = 1] = "error", h[h.warn = 2] = "warn", h[h.debug = 3] = "debug", h[h.info = 4] = "info", function (e) {
    e.response_body = "rsb", e.request_body = "rqb", e.response_headers = "rsh", e.request_headers = "rqh";
  }(T || (T = {})), function (e) {
    e.response_body = "rsb", e.request_body = "rqb", e.response_headers = "rsh", e.request_headers = "rqh";
  }(m || (m = {})), function (e) {
    var t;
    e.TRACEPARENT_HEADER_KEY = "traceparent", (t = e.CONFIG_PREFERENCES || (e.CONFIG_PREFERENCES = {}))[t.APP = 0] = "APP", t[t.REMOTE = 1] = "REMOTE", t[t.MERGE = 2] = "MERGE", function (e) {
      e[e.DISABLED = 0] = "DISABLED", e[e.PERFORMANCE_TIMING = 1] = "PERFORMANCE_TIMING", e[e.PERFORMANCE_NAVIGATION_TIMING = 2] = "PERFORMANCE_NAVIGATION_TIMING";
    }(e.PERFORMANCE_CONTEXT || (e.PERFORMANCE_CONTEXT = {})), e.REMOTE_CONFIG_STORAGE_KEY = "ConvivaRemoteConfig", e.END_POINT_STORAGE_KEY = "ConvivaEndpoint", e.DEFAULT_END_POINT = "https://appgw.conviva.com", e.REMOTE_CONFIG_URL_PREFIX = "https://rc.conviva.com/js/", e.REMOTE_CONFIG_FILE_NAME = "/remote_config.json";
  }(C || (C = {})), function (e) {
    e[e.APP = 0] = "APP", e[e.REMOTE = 1] = "REMOTE", e[e.MERGE = 2] = "MERGE";
  }(y || (y = {}));
  var b,
      O = {},
      N = {},
      _ = {},
      P = !1,
      R = !1;
  e.LinkClickTrackingPlugin = function () {
    return {
      activateBrowserPlugin: function activateBrowserPlugin(e) {
        O[e.id] = e;
      }
    };
  }, e.enableButtonClickTracking = function (e, t) {
    if (void 0 === e && (e = {}), void 0 === t && (t = Object.keys(O)), R = !0, !P) try {
      var n = document.body;
      new MutationObserver(p).observe(n, {
        childList: !0,
        subtree: !0
      });
    } catch (e) {
      console.log("exception", e);
    }
    t.forEach(function (t) {
      try {
        O[t] && (O[t].sharedState.hasLoaded ? (k(e, t), g(t)) : O[t].sharedState.registeredOnLoadHandlers.push(function () {
          k(e, t), g(t);
        }));
      } catch (e) {
        console.warn("Conviva App Tracker caused Exception in enableButtonClickTracking method in click tracking Plugin", e);
      }
    });
  }, e.enableLinkClickTracking = function (e, t) {
    if (void 0 === e && (e = {}), void 0 === t && (t = Object.keys(O)), P = !0, !R) try {
      var n = document.body;
      new MutationObserver(p).observe(n, {
        childList: !0,
        subtree: !0
      });
    } catch (e) {}
    t.forEach(function (t) {
      try {
        O[t] && (O[t].sharedState.hasLoaded ? (f(e, t), v(t)) : O[t].sharedState.registeredOnLoadHandlers.push(function () {
          f(e, t), v(t);
        }));
      } catch (e) {
        console.warn("Conviva App Tracker caused Exception in enableLinkClickTracking method in click tracking Plugin", e);
      }
    });
  }, e.refreshButtonClickTracking = function (e) {
    void 0 === e && (e = Object.keys(O)), e.forEach(function (e) {
      O[e] && (O[e].sharedState.hasLoaded ? g(e) : O[e].sharedState.registeredOnLoadHandlers.push(function () {
        g(e);
      }));
    });
  }, e.refreshLinkClickTracking = function (e) {
    void 0 === e && (e = Object.keys(O)), e.forEach(function (e) {
      O[e] && (O[e].sharedState.hasLoaded ? v(e) : O[e].sharedState.registeredOnLoadHandlers.push(function () {
        v(e);
      }));
    });
  }, e.trackButtonClick = function (e, n) {
    void 0 === n && (n = Object.keys(O));

    for (var r = 0; r < n.length; r++) {
      var i = n[r];

      if (O.hasOwnProperty(i)) {
        var a = e;
        (i = O[i]).core.getConfig().buttonClickTracking && i.core.track(o(a), t(void 0, void 0));
      }
    }
  }, e.trackLinkClick = function (e, n) {
    void 0 === n && (n = Object.keys(O));

    for (var o = 0; o < n.length; o++) {
      var i = n[o];

      if (O.hasOwnProperty(i)) {
        var a = e;
        (i = O[i]).core.getConfig().linkClickTracking && i.core.track(r(a), t(void 0, void 0));
      }
    }
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});